import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, tap } from "rxjs/operators";
import { RankingEndpointsService } from "src/app/api/services";
import * as fromActions from './lastplayers.actions';
import { of } from "rxjs";
import { RankListResponseWrapper } from "src/app/api/models";

@Injectable()
export class LastplayerEffects {

    loadLastplayers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.loadMany),
            mergeMap(({ room, nameSpace }) =>

                this.api.getLastPlayers({ roomId: room, nameSpace: nameSpace }).pipe(
                    map((lastplayers: RankListResponseWrapper) => {
                        return fromActions.loadManySuccess({ items: [lastplayers] })
                    }),
                    catchError(error =>
                        of(fromActions.loadManyFail({ error })),
                    ),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private api: RankingEndpointsService,
    ) { }

}